import { FC } from "react";
import { useRouteMatch } from "react-router-dom";
import { ExploreButtonFilled, ExploreButtonHollow } from "shared/pages/explore/styles";

export const SwitcherButtons: FC<{ type: string, text: string, action: () => void, hide?: boolean, isShouldVisibleLMSButton?: boolean }> = ({ type, text, action, hide, isShouldVisibleLMSButton }) => {
    const isForcedLanding = !!useRouteMatch(['/brnd', '/teams/:teamName/brnd', '/teams/:teamName'])?.isExact
    
    if (hide) {
        return null;
    }
    
    return (
        <>
        {type === 'filled' ? (
            <ExploreButtonFilled className={isShouldVisibleLMSButton || isForcedLanding ? 'lg-switch-button filled-button context-button' : 'lg-switch-button longread-button filled-button context-button'} fixedSize onClick={action}>
                {text}
            </ExploreButtonFilled>
        ) : (
            <ExploreButtonHollow className={isShouldVisibleLMSButton || isForcedLanding ? 'lg-switch-button filled-button context-button' : 'lg-switch-button longread-button hollow-button context-button'} fixedSize onClick={action}>
                {text}
            </ExploreButtonHollow>
        )}
        </>
    )
}import { FC } from "react";
import { useRouteMatch } from "react-router-dom";
import { ExploreButtonFilled, ExploreButtonHollow } from "shared/pages/explore/styles";

export const SwitcherButtons: FC<{ type: string, text: string, action: () => void, hide?: boolean, isShouldVisibleLMSButton?: boolean }> = ({ type, text, action, hide, isShouldVisibleLMSButton }) => {
    const isForcedLanding = !!useRouteMatch(['/brnd', '/teams/:teamName/brnd', '/teams/:teamName'])?.isExact
    
    if (hide) {
        return null;
    }
    
    return (
        <>
        {type === 'filled' ? (
            <ExploreButtonFilled className={isShouldVisibleLMSButton || isForcedLanding ? 'lg-switch-button filled-button context-button' : 'lg-switch-button longread-button filled-button context-button'} fixedSize onClick={action}>
                {text}
            </ExploreButtonFilled>
        ) : (
            <ExploreButtonHollow className={isShouldVisibleLMSButton || isForcedLanding ? 'lg-switch-button filled-button context-button' : 'lg-switch-button longread-button hollow-button context-button'} fixedSize onClick={action}>
                {text}
            </ExploreButtonHollow>
        )}
        </>
    )
}